/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../src/app/app.module';
import * as i2 from '../../../src/app/app.component';
import * as i3 from './modals/about/about-dialog.component.ngfactory';
import * as i4 from './modals/billing/billing-dialog.component.ngfactory';
import * as i5 from './licensing/licensing-modal.component.ngfactory';
import * as i6 from './main/dashboard.component.ngfactory';
import * as i7 from './main/config/config.component.ngfactory';
import * as i8 from './main/history/history.component.ngfactory';
import * as i9 from './trial/trial.component.ngfactory';
import * as i10 from './login/user-login.component.ngfactory';
import * as i11 from './licensing/licensing.component.ngfactory';
import * as i12 from './release-notes/release-notes.component.ngfactory';
import * as i13 from './app.component.ngfactory';
import * as i14 from '@angular/common';
import * as i15 from '@angular/platform-browser';
import * as i16 from '@angular/animations/browser';
import * as i17 from '@angular/platform-browser/animations';
import * as i18 from '@angular/http';
import * as i19 from '../../../src/app/aws/sdk';
import * as i20 from '../../../src/app/aws/signature';
import * as i21 from '../../../src/app/aws/environment';
import * as i22 from '../../../src/app/aws/http';
import * as i23 from '@angular/forms';
import * as i24 from '../../../src/app/mqtt/mqtt.service';
import * as i25 from '../../../src/app/publisher/publisher.service';
import * as i26 from '../../../src/app/restapi/error-handler';
import * as i27 from '../../../src/app/user/preferences.service';
import * as i28 from '../../../src/app/user/user.service';
import * as i29 from '@angular/router';
import * as i30 from '../../../src/app/systeminformation/systeminformation.service';
import * as i31 from '../../../src/app/util/observable-utils';
import * as i32 from '../../../src/app/billing/billing.service';
import * as i33 from '../../../src/app/main/target-validation/target-validation.service';
import * as i34 from '../../../src/app/headerfooter/setting-entries/target-validation-entry';
import * as i35 from '../../../src/app/headerfooter/setting-entries/tos-entry';
import * as i36 from '../../../src/app/headerfooter/setting-entries/billing-entry';
import * as i37 from '../../../src/app/headerfooter/setting-entries/help-entry';
import * as i38 from '../../../src/app/headerfooter/setting-entries/help-pdf-entry';
import * as i39 from '../../../src/app/headerfooter/setting-entries/api-help-entry';
import * as i40 from '../../../src/app/headerfooter/setting-entries/api-help-pdf-entry';
import * as i41 from '../../../src/app/headerfooter/setting-entries/python-api-entry';
import * as i42 from '../../../src/app/headerfooter/setting-entries/support-entry';
import * as i43 from '../../../src/app/headerfooter/setting-entries/about-entry';
import * as i44 from '../../../src/app/headerfooter/setting-entries/logout-entry';
import * as i45 from '../../../src/app/headerfooter/header.service';
import * as i46 from '../../../src/app/login/user-login.service';
import * as i47 from '@swimlane/ngx-datatable/release/services/scrollbar-helper.service';
import * as i48 from '@angular/animations';
import * as i49 from 'ngx-window-token/dist/src/ngx-window-token';
import * as i50 from 'ngx-clipboard/src/clipboard.service';
import * as i51 from '../../../src/app/attack/attack.service';
import * as i52 from '../../../src/app/main/config/config.service';
import * as i53 from '../../../src/app/notifier/notifier.service';
import * as i54 from '../../../src/app/modals/modal.service';
import * as i55 from '../../../src/app/router/auth-guard.service';
import * as i56 from '../../../src/app/trial/trial.service';
import * as i57 from '../../../src/app/router/trial-auth-guard.service';
import * as i58 from '../../../src/app/main/dashboard.component';
import * as i59 from '../../../src/app/main/config/config.component';
import * as i60 from '../../../src/app/main/history/history.component';
import * as i61 from '../../../src/app/trial/trial.component';
import * as i62 from '../../../src/app/login/user-login.component';
import * as i63 from '../../../src/app/licensing/licensing.component';
import * as i64 from '../../../src/app/release-notes/release-notes.component';
import * as i65 from '../../../src/app/aws/aws.module';
import * as i66 from '../../../src/app/mqtt/mqtt.module';
import * as i67 from '../../../src/app/publisher/publisher.module';
import * as i68 from '../../../src/app/user/user.module';
import * as i69 from '../../../src/app/progress/progress.module';
import * as i70 from '../../../src/app/systeminformation/systeminformation.module';
import * as i71 from '../../../src/app/util/util.module';
import * as i72 from '../../../src/app/billing/billing.module';
import * as i73 from '../../../src/app/modals/modals.module';
import * as i74 from '../../../src/app/headerfooter/headerfooter.module';
import * as i75 from '../../../src/app/licensing/licensing.module';
import * as i76 from '../../../src/app/restapi/restapi.module';
import * as i77 from '../../../src/app/login/login.module';
import * as i78 from '../../../src/app/main/main-routing.module';
import * as i79 from '@swimlane/ngx-datatable/release/datatable.module';
import * as i80 from '../../../src/app/pipes/pipes.module';
import * as i81 from 'ngx-clipboard/src/index';
import * as i82 from '../../../src/app/main/main.module';
import * as i83 from '../../../src/app/tree/tree.module';
export const AppModuleNgFactory:i0.NgModuleFactory<i1.AppModule> = i0.ɵcmf(i1.AppModule,
    [i2.AppComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.AboutDialogComponentNgFactory,i4.BillingDialogNgFactory,i5.LicensingModalNgFactory,
              i6.DashboardComponentNgFactory,i7.ConfigComponentNgFactory,i8.HistoryComponentNgFactory,
              i9.TrialComponentNgFactory,i10.UserLoginComponentNgFactory,i11.LicensingComponentNgFactory,
              i12.ReleaseNotesComponentNgFactory,i13.AppComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i14.NgLocalization,i14.NgLocaleLocalization,[i0.LOCALE_ID]),
          i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,
              i0.ɵk,([] as any[])),i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),
          i0.ɵmpd(4608,i15.DomSanitizer,i15.ɵe,[i14.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,
              (null as any),[i15.DomSanitizer]),i0.ɵmpd(4608,i15.HAMMER_GESTURE_CONFIG,
              i15.HammerGestureConfig,([] as any[])),i0.ɵmpd(5120,i15.EVENT_MANAGER_PLUGINS,
              (p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
                return [new i15.ɵDomEventsPlugin(p0_0),new i15.ɵKeyEventsPlugin(p1_0),
                    new i15.ɵHammerGesturesPlugin(p2_0,p2_1)];
              },[i14.DOCUMENT,i14.DOCUMENT,i14.DOCUMENT,i15.HAMMER_GESTURE_CONFIG]),
          i0.ɵmpd(4608,i15.EventManager,i15.EventManager,[i15.EVENT_MANAGER_PLUGINS,
              i0.NgZone]),i0.ɵmpd(135680,i15.ɵDomSharedStylesHost,i15.ɵDomSharedStylesHost,
              [i14.DOCUMENT]),i0.ɵmpd(4608,i15.ɵDomRendererFactory2,i15.ɵDomRendererFactory2,
              [i15.EventManager,i15.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i16.AnimationDriver,
              i17.ɵc,([] as any[])),i0.ɵmpd(5120,i16.ɵAnimationStyleNormalizer,i17.ɵd,
              ([] as any[])),i0.ɵmpd(4608,i16.ɵAnimationEngine,i17.ɵb,[i16.AnimationDriver,
              i16.ɵAnimationStyleNormalizer]),i0.ɵmpd(5120,i0.RendererFactory2,i17.ɵe,
              [i15.ɵDomRendererFactory2,i16.ɵAnimationEngine,i0.NgZone]),i0.ɵmpd(6144,
              i15.ɵSharedStylesHost,(null as any),[i15.ɵDomSharedStylesHost]),i0.ɵmpd(4608,
              i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i15.Meta,i15.Meta,
              [i14.DOCUMENT]),i0.ɵmpd(4608,i15.Title,i15.Title,[i14.DOCUMENT]),i0.ɵmpd(4608,
              i18.BrowserXhr,i18.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i18.ResponseOptions,
              i18.BaseResponseOptions,([] as any[])),i0.ɵmpd(5120,i18.XSRFStrategy,
              i18.ɵb,([] as any[])),i0.ɵmpd(4608,i18.XHRBackend,i18.XHRBackend,[i18.BrowserXhr,
              i18.ResponseOptions,i18.XSRFStrategy]),i0.ɵmpd(4608,i18.RequestOptions,
              i18.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,i18.Http,i18.ɵc,[i18.XHRBackend,
              i18.RequestOptions]),i0.ɵmpd(4608,i19.AwsSdk,i19.AwsSdk,([] as any[])),
          i0.ɵmpd(4608,i20.AwsSignature,i20.AwsSignature,([] as any[])),i0.ɵmpd(5120,
              i21.AwsEnvironment,i21.createAwsEnv,([] as any[])),i0.ɵmpd(4608,i22.AwsHttp,
              i22.AwsHttp,[i18.Http,i20.AwsSignature,i21.AwsEnvironment]),i0.ɵmpd(4608,
              i23.ɵi,i23.ɵi,([] as any[])),i0.ɵmpd(4608,i24.MQTTService,i24.MQTTService,
              [i20.AwsSignature,i21.AwsEnvironment]),i0.ɵmpd(4608,i25.PublisherService,
              i25.PublisherService,([] as any[])),i0.ɵmpd(4608,i26.ErrorHandler,i26.ErrorHandler,
              ([] as any[])),i0.ɵmpd(4608,i27.UserPreferencesService,i27.UserPreferencesService,
              [i22.AwsHttp,i26.ErrorHandler]),i0.ɵmpd(4608,i28.UserService,i28.UserService,
              [i21.AwsEnvironment,i19.AwsSdk,i27.UserPreferencesService,i24.MQTTService,
                  i29.Router,i25.PublisherService]),i0.ɵmpd(4608,i30.SystemInformationService,
              i30.SystemInformationService,[i22.AwsHttp,i26.ErrorHandler,i28.UserService]),
          i0.ɵmpd(4608,i31.ObservableUtils,i31.ObservableUtils,([] as any[])),i0.ɵmpd(4608,
              i32.BillingService,i32.BillingService,[i22.AwsHttp,i26.ErrorHandler,
                  i31.ObservableUtils,i28.UserService]),i0.ɵmpd(4608,i33.TargetValidationService,
              i33.TargetValidationService,[i29.Router,i22.AwsHttp,i26.ErrorHandler,
                  i28.UserService,i25.PublisherService]),i0.ɵmpd(5120,'SettingsEntry',
              (p0_0:any,p1_0:any,p2_0:any,p7_0:any,p7_1:any,p7_2:any,p7_3:any,p9_0:any,
                  p10_0:any) => {
                return [new i34.TargetValidationEntry(p0_0),new i35.TOSEntry(p1_0),
                    new i36.BillingEntry(p2_0),new i37.HelpEntry(),new i38.HelpPdfEntry(),
                    new i39.ApiHelpEntry(),new i40.ApiHelpPdfEntry(),new i41.PythonApiEntry(p7_0,
                        p7_1,p7_2,p7_3),new i42.SupportEntry(),new i43.AboutEntry(p9_0),
                    new i44.LogOutEntry(p10_0)];
              },[i33.TargetValidationService,i0.ComponentFactoryResolver,i0.ComponentFactoryResolver,
                  i18.Http,i26.ErrorHandler,i28.UserService,i22.AwsHttp,i0.ComponentFactoryResolver,
                  i28.UserService]),i0.ɵmpd(5120,i29.ActivatedRoute,i29.ɵf,[i29.Router]),
          i0.ɵmpd(4608,i45.HeaderService,i45.HeaderService,[i25.PublisherService,i29.Router,
              i29.ActivatedRoute]),i0.ɵmpd(4608,i46.LoginService,i46.LoginService,
              [i18.Http,i21.AwsEnvironment,i26.ErrorHandler]),i0.ɵmpd(4608,i47.ScrollbarHelper,
              i47.ScrollbarHelper,[i15.DOCUMENT]),i0.ɵmpd(4608,i48.AnimationBuilder,
              i17.ɵBrowserAnimationBuilder,[i0.RendererFactory2,i15.DOCUMENT]),i0.ɵmpd(5120,
              i49.WINDOW,i49._window,([] as any[])),i0.ɵmpd(5120,i50.ClipboardService,
              i50.CLIPBOARD_SERVICE_PROVIDER_FACTORY,[i15.DOCUMENT,i49.WINDOW,[3,i50.ClipboardService]]),
          i0.ɵmpd(4608,i51.AttackService,i51.AttackService,[i22.AwsHttp,i26.ErrorHandler,
              i28.UserService,i25.PublisherService]),i0.ɵmpd(4608,i52.ConfigService,
              i52.ConfigService,[i51.AttackService,i25.PublisherService]),i0.ɵmpd(4608,
              i53.NotifierService,i53.NotifierService,([] as any[])),i0.ɵmpd(4608,
              i54.ModalService,i54.ModalService,([] as any[])),i0.ɵmpd(4608,i29.NoPreloading,
              i29.NoPreloading,([] as any[])),i0.ɵmpd(6144,i29.PreloadingStrategy,
              (null as any),[i29.NoPreloading]),i0.ɵmpd(135680,i29.RouterPreloader,
              i29.RouterPreloader,[i29.Router,i0.NgModuleFactoryLoader,i0.Compiler,
                  i0.Injector,i29.PreloadingStrategy]),i0.ɵmpd(4608,i29.PreloadAllModules,
              i29.PreloadAllModules,([] as any[])),i0.ɵmpd(5120,i29.ROUTER_INITIALIZER,
              i29.ɵi,[i29.ɵg]),i0.ɵmpd(5120,i0.APP_BOOTSTRAP_LISTENER,(p0_0:any) => {
            return [p0_0];
          },[i29.ROUTER_INITIALIZER]),i0.ɵmpd(4608,i55.AuthGuard,i55.AuthGuard,[i28.UserService,
              i29.Router]),i0.ɵmpd(4608,i56.TrialService,i56.TrialService,[i26.ErrorHandler,
              i21.AwsEnvironment,i18.Http,i22.AwsHttp,i28.UserService]),i0.ɵmpd(4608,
              i57.TrialAuthGuardService,i57.TrialAuthGuardService,[i28.UserService,
                  i29.Router,i56.TrialService]),i0.ɵmpd(4608,i35.TOSEntry,i35.TOSEntry,
              [i0.ComponentFactoryResolver]),i0.ɵmpd(512,i14.CommonModule,i14.CommonModule,
              ([] as any[])),i0.ɵmpd(1024,i0.ErrorHandler,i15.ɵa,([] as any[])),i0.ɵmpd(1024,
              i0.NgProbeToken,() => {
                return [i29.ɵb()];
              },([] as any[])),i0.ɵmpd(512,i29.ɵg,i29.ɵg,[i0.Injector]),i0.ɵmpd(1024,
              i0.APP_INITIALIZER,(p0_0:any,p0_1:any,p1_0:any) => {
                return [i15.ɵc(p0_0,p0_1),i29.ɵh(p1_0)];
              },[[2,i15.NgProbeToken],[2,i0.NgProbeToken],i29.ɵg]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i15.BrowserModule,i15.BrowserModule,[[3,i15.BrowserModule]]),
          i0.ɵmpd(1024,i29.ɵa,i29.ɵd,[[3,i29.Router]]),i0.ɵmpd(512,i29.UrlSerializer,
              i29.DefaultUrlSerializer,([] as any[])),i0.ɵmpd(512,i29.ChildrenOutletContexts,
              i29.ChildrenOutletContexts,([] as any[])),i0.ɵmpd(256,i29.ROUTER_CONFIGURATION,
              {},([] as any[])),i0.ɵmpd(1024,i14.LocationStrategy,i29.ɵc,[i14.PlatformLocation,
              [2,i14.APP_BASE_HREF],i29.ROUTER_CONFIGURATION]),i0.ɵmpd(512,i14.Location,
              i14.Location,[i14.LocationStrategy]),i0.ɵmpd(512,i0.Compiler,i0.Compiler,
              ([] as any[])),i0.ɵmpd(512,i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,
              [i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),i0.ɵmpd(1024,i29.ROUTES,
              () => {
                return [[{path:'',component:i58.DashboardComponent,canActivate:[i55.AuthGuard],
                    children:[{path:'',component:i59.ConfigComponent},{path:'history',
                        component:i60.HistoryComponent}]}],[{path:'',redirectTo:'/dashboard',
                    pathMatch:'full'},{path:'trial',component:i61.TrialComponent,canActivate:[i57.TrialAuthGuardService]},
                    {path:'login',component:i62.UserLoginComponent},{path:'dashboard',
                        component:i58.DashboardComponent,redirectTo:'',canActivate:[i55.AuthGuard]},
                    {path:'tos',component:i63.LicensingComponent},{path:'eula',component:i63.LicensingComponent},
                    {path:'release-notes',component:i64.ReleaseNotesComponent},{path:'**',
                        redirectTo:''}]];
              },([] as any[])),i0.ɵmpd(1024,i29.Router,i29.ɵe,[i0.ApplicationRef,i29.UrlSerializer,
              i29.ChildrenOutletContexts,i14.Location,i0.Injector,i0.NgModuleFactoryLoader,
              i0.Compiler,i29.ROUTES,i29.ROUTER_CONFIGURATION,[2,i29.UrlHandlingStrategy],
              [2,i29.RouteReuseStrategy]]),i0.ɵmpd(512,i29.RouterModule,i29.RouterModule,
              [[2,i29.ɵa],[2,i29.Router]]),i0.ɵmpd(512,i18.HttpModule,i18.HttpModule,
              ([] as any[])),i0.ɵmpd(512,i65.AwsModule,i65.AwsModule,([] as any[])),
          i0.ɵmpd(512,i23.ɵba,i23.ɵba,([] as any[])),i0.ɵmpd(512,i23.FormsModule,i23.FormsModule,
              ([] as any[])),i0.ɵmpd(512,i66.MQTTModule,i66.MQTTModule,([] as any[])),
          i0.ɵmpd(512,i67.PublisherModule,i67.PublisherModule,([] as any[])),i0.ɵmpd(512,
              i68.UserModule,i68.UserModule,([] as any[])),i0.ɵmpd(512,i69.ProgressModule,
              i69.ProgressModule,([] as any[])),i0.ɵmpd(512,i70.SystemInformationModule,
              i70.SystemInformationModule,([] as any[])),i0.ɵmpd(512,i71.UtilModule,
              i71.UtilModule,([] as any[])),i0.ɵmpd(512,i72.BillingModule,i72.BillingModule,
              ([] as any[])),i0.ɵmpd(512,i73.ModalsModule,i73.ModalsModule,([] as any[])),
          i0.ɵmpd(512,i74.HeaderFooterModule,i74.HeaderFooterModule,([] as any[])),
          i0.ɵmpd(512,i75.LicensingModule,i75.LicensingModule,([] as any[])),i0.ɵmpd(512,
              i76.RestApiModule,i76.RestApiModule,([] as any[])),i0.ɵmpd(512,i77.LoginModule,
              i77.LoginModule,([] as any[])),i0.ɵmpd(512,i78.MainRoutingModule,i78.MainRoutingModule,
              ([] as any[])),i0.ɵmpd(512,i79.NgxDatatableModule,i79.NgxDatatableModule,
              ([] as any[])),i0.ɵmpd(512,i80.PipesModule,i80.PipesModule,([] as any[])),
          i0.ɵmpd(512,i17.BrowserAnimationsModule,i17.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i49.WindowTokenModule,i49.WindowTokenModule,([] as any[])),i0.ɵmpd(512,
              i81.ClipboardModule,i81.ClipboardModule,([] as any[])),i0.ɵmpd(512,i82.MainModule,
              i82.MainModule,([] as any[])),i0.ɵmpd(512,i83.TreeModule,i83.TreeModule,
              ([] as any[])),i0.ɵmpd(512,i1.AppModule,i1.AppModule,([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2FwcC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vc3JjL3VpL3NyYy9hcHAvYXBwLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./aot_output/src/app/app.module.ngfactory.ts